import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import Tooltip from '@material-ui/core/Tooltip';
import CompareArrows from '@material-ui/icons/CompareArrows';
import CheckIcon from '@material-ui/icons/Check';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import ByLotIcon from '@material-ui/icons/Receipt';
import WRTIcon from '@material-ui/icons/Flag';
import WADIcon from '@material-ui/icons/LocalShipping';
import AtDestinationIcon from '@material-ui/icons/MyLocation';
import { handleServerError } from '../../Utils/Helper';
import LinearProgress from '../Utils/LinearProgress';
import NOLSSyncAPI from '../../API/NOLSSyncAPI';
import SnackbarAlert from '../Utils/SnackbarAlert';

const styles = theme => ({
  paperRoot: {
    width: '100%',
    backgroundColor: '#F6F6F6',
  },
  noMargin: {
    margin: 0
  },
  width100: {
    width: '100%'
  },
  button: {
    margin: theme.spacing.unit
  },
  buttonSize: {
    width: '36px',
    height: '36px'
  },
  secondToolBar: {
    padding: '0px 12px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    height: '52px'
  },
  buttonPlaceHolder: {
    display: 'flex',
    alignItems: 'inherit'
  },
});

export class TransportsEntry extends Component {

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      success: false,
      content: this.props.showContent
    };
  }

  handleUpdateGeneralDefinitionsSGE = () => {
    const nolsSyncAPI = new NOLSSyncAPI();
    this.setState({ loading: true })
    nolsSyncAPI.sendUpdateOrderL4All().then(() => {
      this.setState({
        loading: false,
        success: true,
      });
      setTimeout(() => {
        this.setState({
          success: false
        });
      }, 500)
    }).catch((error) => {
      this.setState({
        loading: false,
        success: false,
        openError: true,
        alertMessage: handleServerError(error)
      })
    });
  };

  handleButtonClick = (newContent) => {
    this.props.handleChangeContent(newContent);
  };

  handleCloseSnackbar = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    this.setState({
      openError: false,
      alertMessage: ''
    });
  };

  render() {
    const { classes } = this.props;
    const { loading, success } = this.state;
    const buttonClassname = classNames({ [classes.buttonSuccess]: success });

    return (
      <Paper className={classes.paperRoot}>

        <div className={classes.secondToolBar}>
          <Typography variant='title' id='tableTitle'>
            GESTÃO DE TRANSPORTE - COMPRAS FIRMES
          </Typography>

          {loading && <LinearProgress />}

          <Tooltip title='Ligação ao NOLS' placement='bottom' >
            <Button disabled={loading} variant='fab' color='primary' className={classNames(classes.button, classes.buttonSize, buttonClassname)} onClick={this.handleUpdateGeneralDefinitionsSGE}>
              {success ? <CheckIcon /> : <CompareArrows />}
            </Button>
          </Tooltip>
        </div>

        <Grid container spacing={32} className={classNames(classes.width100, classes.noMargin)}>
          <Grid item xs={12} sm={6}>
            <Button color='primary' variant='contained' className={classes.width100} onClick={() => { this.handleButtonClick('transportsByLot') }}>
              <ByLotIcon className={classes.button} />
              POR LOTE
            </Button>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Button color='primary' variant='contained' className={classes.width100} onClick={() => { this.handleButtonClick('transportsWaitingRequest') }}>
              <WRTIcon className={classes.button} />
              A AGUARDAR PEDIDO DE TRANSPORTE
            </Button>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Button color='primary' variant='contained' className={classes.width100} onClick={() => { this.handleButtonClick('transportsWaitingArrival') }}>
              <WADIcon className={classes.button} />
              A AGUARDAR CHEGADA AO DESTINO
            </Button>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Button color='primary' variant='contained' className={classes.width100} onClick={() => { this.handleButtonClick('transportsAtDestination') }}>
              <AtDestinationIcon className={classes.button} />
              NO DESTINO
            </Button>
          </Grid>
        </Grid>

        <SnackbarAlert autoHideDuration={this.state.autoHideDuration} openSuccess={this.state.openSuccess} openError={this.state.openError} alertMessage={this.state.alertMessage} handleCloseSnackbar={this.handleCloseSnackbar} />

      </Paper>
    )
  }
}

export default TransportsEntry = withStyles(styles)(TransportsEntry);


// WEBPACK FOOTER //
// ./src/components/Transports/TransportsEntry.js